import { FormFields } from ".";
import { INDIAN_CITIES, INDIAN_STATES } from "./indiaStatesList";

export const MEMBERSHIP_DETAILS_FIELDS: FormFields = {
  fields: [
    {
      name: "name",
      label: "PIL Member Name",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "memberId",
      label: "PIL Member ID",
      type: "text",
      validationRules: {
        required: false,
        pattern: {
          value: /^[a-zA-Z0-9]{5,20}$/,
          message: "Member ID must be 5-20 alphanumeric characters",
        },
      },
    },
    {
      name: "category",
      label: "Category",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "enrollmentDate",
      label: "Enrollment Date",
      type: "date",
      validationRules: {
        required: false,
      },
    },
    {
      name: "clubName",
      label: "Club Name",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "clubId",
      label: "Club ID",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "bdName",
      label: "BD Name",
      type: "text",
      validationRules: {
        required: false,
      },
    },
    {
      name: "bdPhoneNumber",
      label: "BD Phone Number",
      type: "tel",
      validationRules: {
        required: false,
        pattern: {
          value: /^[6-9]\d{9}$/,
          message: "Phone number must be 10 digits and start with 6-9",
        },
      },
    },
    {
      name: "city",
      label: "City",
      type: "select",
      options: INDIAN_CITIES,
      validationRules: {
        required: false,
      },
    },
    {
      name: "state",
      label: "State",
      type: "select",
      options: INDIAN_STATES,
      validationRules: {
        required: false,
      },
    },
    {
      name: "pinCode",
      label: "PIN Code",
      type: "text",
      validationRules: {
        required: false,
        pattern: {
          value: /^\d{6}$/,
          message: "PIN code must be 6 digits",
        },
      },
    },
  ],
};
